import { render, staticRenderFns } from "./ReplyTicket.vue?vue&type=template&id=24e4749c&scoped=true&"
import script from "./ReplyTicket.vue?vue&type=script&lang=js&"
export * from "./ReplyTicket.vue?vue&type=script&lang=js&"
import style0 from "./ReplyTicket.vue?vue&type=style&index=0&id=24e4749c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e4749c",
  null
  
)

export default component.exports